import { TPanelField } from '@/shared/interfaces/custom-content-store';

// TODO: Add unit testing
/**
 * Based on the panel template fields created by the superadmin, return their value or values
 * if checkbox or feature-buildings subtype, return values and selected ones,
 * select options and remaining subtypes will return value and not the plural values.
 * @param fields Panel Template Fields to return its value
 * @returns Array fields based on the panel template
*/
export const getFieldsFromTemplate = (fields: TPanelField[]) => fields.map<TPanelField>((pt) => {
  type TOption = { value: string, label: string, selected: boolean };

  let valueData: { value?: string, values?: string[] | number[] };

  const optionValues = ((pt.values as unknown as Array<TOption> | null) ?? [])
    .filter((v) => !!v);

  if (pt.subtype === 'checkbox-group' && pt.values) {
    valueData = { values: optionValues.filter((f) => f.selected).map((v) => v.value) };
  } else if (pt.subtype === 'feature-buildings' && pt.values) {
    valueData = { values: pt.values };
  } else if (pt.subtype === 'select-options' && pt.values) {
    valueData = { value: optionValues.find((f) => f.selected)?.value ?? '' };
  } else {
    valueData = { value: pt.value ?? '' };
  }

  return {
    name: pt.name,
    subtype: pt.subtype,
    ...valueData,
  };
});
